import { useInView } from 'react-intersection-observer';

export default function StorySection({
  index,
  setActive,
  component,
  title,
  subtitle,
}) {
  const { ref } = useInView({
    // trigger when roughly 60% of the section is visible
    root: null,
    rootMargin: '0px 0px -40% 0px',
    threshold: 0,
    onChange: (inView) => {
      if (inView) setActive(index);
    },
  });

  return (
    <section
      ref={ref}
      className="min-h-screen flex flex-col items-center p-16 space-y-10"
    >
      {title && (
        <div className="items-center justify-center text-center">
          <p className="text-banner-title text-7xl">{title}</p>
          {subtitle && (
            <p className="text-banner-subtitle text-3xl">{subtitle}</p>
          )}
        </div>
      )}
      <div className="min-h-screen w-full flex items-center">{component}</div>
    </section>
  );
}
